import React, { memo, useEffect, useState } from 'react';

import { GrayInfoIcon } from 'features/order-tracker/shared-components/svg';
import { removeSpacesFromString } from 'features/order-tracker/utils';

import { Tooltip } from '../Tooltip';

import { INPUT_PLACEHOLDER_BY_ID } from './constants';

import styles from './styles.module.scss';

export const Input: React.FC<sharedComponents.InputProps> = (props) => {
  const { id, value, onInputChange, onKeyUpSubmit, label, tooltip, errorText, testId } = props;
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(!!errorText);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const val = e.target.value;
    setIsShowErrorMessage(false);
    onInputChange(removeSpacesFromString(val) || '');
  };

  const onKeyUpHandler = ({ key }: React.KeyboardEvent): void => {
    onKeyUpSubmit(key);
  };

  useEffect(() => {
    setIsShowErrorMessage(!!errorText);
  }, [errorText]);

  return (
    <div className={styles.formItem}>
      <div className={styles.formInputContainer}>
        <label htmlFor={id} className={styles.label}>
          {label}
          <Tooltip
            tooltip={tooltip}
            className={styles.tooltipContainer}
          >
            <GrayInfoIcon />
          </Tooltip>
        </label>
        <input
          data-testid={testId}
          id={id}
          className={styles.formInput}
          type="text"
          onChange={onChangeHandler}
          onKeyUp={onKeyUpHandler}
          value={value}
          placeholder={INPUT_PLACEHOLDER_BY_ID[id]}
        />
        {isShowErrorMessage && (
          <div className={styles.formInputError}>
            <p>{errorText}</p>
          </div>
        )}
      </div>
    </div>
  );
};

const handleInputRerender = (prevProps: sharedComponents.InputProps, newProps: sharedComponents.InputProps): boolean =>
  prevProps.value === newProps.value &&
  prevProps.errorText === newProps.errorText &&
  prevProps.tooltip.title === newProps.tooltip.title;

export const FormInput = memo(Input, handleInputRerender);
